import React from "react"
import { NonRouterModal } from "./Modal"

import CheckIcon from '@mui/icons-material/Check';
import Button from "@mui/material/Button";

import { WorkshopProduct, deleteWorkshopProduct } from "../types/WorkshopProducts";
import Alert, { AlertProps } from '@mui/material/Alert';
import { useSnackbar } from '../../contexts/SnackBarContext';

export const RemoveWorkshopProductModal = ({ wpId, workshopProducts, openState, setOpenState, setWorkshopProducts }:
                                      {wpId: number, workshopProducts: WorkshopProduct[],
                                        openState: boolean, setOpenState: (state: boolean) => void,
                                        setWorkshopProducts: React.Dispatch<React.SetStateAction<WorkshopProduct[]>>
    }) => {
    const { showSnackbar } = useSnackbar();

    const removeHandler = () => {
        deleteWorkshopProduct(wpId, new AbortController()).then(readback => {
            if(!readback.failed)
                setWorkshopProducts(workshopProducts.filter(wp => wp.id !== wpId));
            else
                console.log('readback: ', readback)
            showSnackbar(readback.failed ? 'Delete failed: ' + readback.errorText : 'Product removed', readback.failed ? "error" : "info");
        });
        setOpenState(false);
    };

    return <NonRouterModal title="Confirm removal of product"
                           description='Are you sure?'
                           setOpenState={setOpenState}
                           openState={openState} cancel
                            buttons={[<Button onClick={removeHandler} startIcon={<CheckIcon />}>{'Confirm'}</Button>]}
                            alertComponent={<Alert severity='error'>
                                Confirming the deletion of the product will also delete all tracked test cases and their results.
                            </Alert>}>
                           
    </NonRouterModal>
}